<template>
<div>
    <v-app-bar v-if="!noMenu" app dark flat clipped-left clipped-right class="menu" extension-height="50">
        <v-container :fluid="fullWidth" class="px-4 py-0 fill-height flex-nowrap">
            <router-link v-if="logoLink" :to="logoLink" class="mr-4">
                <img src="/static/logo.svg" height="38" style="vertical-align: middle;" alt="coroot logo">
            </router-link>
            <a v-else href="/" class="mr-4">
                <img src="/static/logo.svg" height="38" style="vertical-align: middle;" alt="coroot logo">
            </a>
            <slot name="menu">
                <div class="d-none d-md-flex align-center">
                    <v-menu dark offset-y tile open-on-hover open-on-click attach=".v-app-bar">
                        <template #activator="{ on }">
                            <a v-on="on" class="px-2 mr-5">Product <v-icon>mdi-menu-down</v-icon></a>
                        </template>
                        <v-list dense class="products">
                            <v-list-item href="/overview">Product Overview</v-list-item>
                            <v-list-item href="https://github.com/coroot/coroot" target="_blank">Coroot Community Edition</v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu dark offset-y tile open-on-hover open-on-click attach=".v-app-bar">
                        <template #activator="{ on }">
                            <a v-on="on" class="px-2 mr-5">Solutions <v-icon>mdi-menu-down</v-icon></a>
                        </template>
                        <v-list dense class="products">
                            <v-list-item href="/kubernetes">Kubernetes Observability</v-list-item>
                            <v-list-item href="/postgres">Postgres Observability</v-list-item>
                        </v-list>
                    </v-menu>
                    <a href="/pricing">Pricing</a>
                    <v-menu dark offset-y tile open-on-hover open-on-click attach=".v-app-bar">
                        <template #activator="{ on }">
                            <a v-on="on" class="px-2 mr-5">Resources <v-icon>mdi-menu-down</v-icon></a>
                        </template>
                        <v-list dense class="products">
                            <v-list-item href="/docs">Docs</v-list-item>
                            <v-list-item href="/blog/minimizing-observability-tax">How it works</v-list-item>
                            <v-list-item href="/blog">Blog</v-list-item>
                        </v-list>
                    </v-menu>
                    <a href="https://community-demo.coroot.com/" target="_blank">Live Demo</a>
                </div>

                <v-spacer />
                <GithubButton :count="$vuetify.breakpoint.width >= 400" class="mr-1 mr-lg-5" />
            </slot>
            <v-app-bar-nav-icon v-if="!noDrawer && !bigScreen" @click="drawer = !drawer" style="margin-right: -8px" />
        </v-container>

        <template v-if="$slots.submenu" #extension>
            <v-container :fluid="fullWidth" class="px-4 py-0 fill-height flex-nowrap submenu">
                <v-tabs light hide-slider show-arrows>
                    <slot name="submenu"></slot>
                </v-tabs>
            </v-container>
        </template>
    </v-app-bar>

    <v-navigation-drawer width="300px" v-if="!noMenu && !noDrawer" app v-model="drawer" clipped :right="!fullWidth" :permanent="fullWidth" disable-resize-watcher>
        <v-list nav class="pa-4 pb-10">
            <slot name="drawer">
                <v-subheader class="px-0">Product</v-subheader>
                <v-list-item href="/overview">Product Overview</v-list-item>
                <v-list-item href="https://github.com/coroot/coroot" target="_blank">Coroot Community Edition</v-list-item>
                <v-list-item href="/open-source-observability-solutions">Open Source Observability Solutions</v-list-item>
                <v-subheader class="px-0">Solutions</v-subheader>
                <v-list-item href="/kubernetes">Kubernetes Observability</v-list-item>
                <v-list-item href="/postgres">Postgres Observability</v-list-item>
                <v-subheader class="px-0">Pricing</v-subheader>
                <v-list-item href="/kubernetes">Pricing</v-list-item>
                <v-subheader class="px-0">Resources</v-subheader>
                <v-list-item href="/docs">Docs</v-list-item>
                <v-list-item href="/blog/minimizing-observability-tax">How it works</v-list-item>
                <v-list-item href="https://community-demo.coroot.com/" target="_blank">Live demo</v-list-item>
                <v-list-item href="/blog">Blog</v-list-item>
            </slot>
        </v-list>
    </v-navigation-drawer>

    <slot name="alert"></slot>

    <v-main :style="{paddingBottom: $vuetify.breakpoint.smAndDown ? '400px' : '300px'}">
        <v-container :fluid="fullWidth && !noFluid" class="px-4 py-0">
            <slot></slot>
        </v-container>
    </v-main>

    <template v-if="$slots.toc">
        <v-navigation-drawer app clipped fixed right floating class="pa-3">
            <slot name="toc"></slot>
        </v-navigation-drawer>
    </template>

    <v-footer v-if="false" app absolute inset padless class="text-center">
        <v-container :fluid="fullWidth" class="pa-3 footer">
            <div class="d-flex flex-wrap align-center justify-center">
                <router-link :to="{name: 'pricing'}" :target="newTab">Pricing</router-link>
                <router-link :to="{name: 'blog', params: {name: 'minimizing-observability-tax'}}" :target="newTab">How it works</router-link>
                <a href="https://community-demo.coroot.com/" target="_blank" class="d-none d-lg-inline">Live demo</a>
                <router-link :to="{name: 'blog'}" :target="newTab">Blog</router-link>
                <router-link :to="{name: 'docs'}" :target="newTab">Docs</router-link>
                <router-link :to="{name: 'terms'}" :target="newTab">Terms of Service</router-link>
                <router-link :to="{name: 'privacy'}" :target="newTab">Privacy policy</router-link>
                <ContactUs />
            </div>
            <div class="d-flex flex-wrap align-center justify-center" style="column-gap: 40px">
                <div class="copy py-2">&copy; {{ new Date().getFullYear() }} Coroot Inc., All Rights Reserved.</div>
            </div>
        </v-container>
    </v-footer>

    <v-alert v-if="this.gdprBanner && $route.name !== 'privacy'" tile color="grey lighten-2" class="mb-0" style="position: fixed; left: 0; bottom: 0; width: 100%; z-index: 100">
        <div class="d-flex flex-column flex-sm-row align-center" style="gap: 20px; row-gap: 20px">
            <div class="flex-grow-1">
                This website uses cookies and similar technologies to give you the best online experience.
                To find out more information please see the <router-link :to="{name: 'privacy'}" target="_blank">privacy policy</router-link>.
            </div>
            <v-btn outlined @click="gdprBannerClose">Accept</v-btn>
        </div>
    </v-alert>
</div>
</template>

<script>
import ContactUs from "@/pages/ContactUs";
import GithubButton from "@/components/GithubButton";

export default {
    components: {ContactUs, GithubButton},
    props: {
        noMenu: Boolean,
        noDrawer: Boolean,
        leftMenu: Boolean,
        logoLink: Object,
        noFluid: Boolean,
    },

    data() {
        return {
            drawer: false,
            gdprBanner: false,
        }
    },

    mounted() {
        this.gdprBannerShow();
    },

    computed: {
        bigScreen() {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        fullWidth() {
            return this.leftMenu && this.bigScreen;
        },
        newTab() {
            return this.$route.matched.some((r) => (r.meta.view === 'console')) ? '_blank' : '';
        },
        profiles() {
            return [
                {icon: 'mdi-twitter', url: 'https://twitter.com/coroot_com'},
                {icon: 'mdi-github', url: 'https://github.com/coroot'},
                {icon: 'mdi-linkedin', url: 'https://www.linkedin.com/company/coroot'},
                {icon: 'mdi-slack', url: 'https://join.slack.com/t/coroot-community/shared_invite/zt-1gsnfo0wj-I~Zvtx5CAAb8vr~r~vecyw'},
                {icon: 'mdi-youtube', url: 'https://www.youtube.com/@coroot_com'},
                {icon: 'mdi-rss', url: '/blog/rss'},
            ];
        },
    },

    methods: {
        gdprBannerShow() {
            // if (!window.Coroot.GdprApplicable || localStorage.getItem('gdpr-banner-closed')) {
            //     return;
            // }
            // this.gdprBanner = true;
        },
        gdprBannerClose() {
            this.gdprBanner = false;
            localStorage.setItem('gdpr-banner-closed', new Date().getTime());
        },
    }
}
</script>

<style scoped>
.link {
    color: white;
    font-weight: 500;
    text-decoration: underline !important;
}

.menu {
    background-color: #080b1d !important;
}
.menu >>> .v-btn {
    min-width: unset !important;
    border-color: rgba(255,255,255,0.2);
}
.menu >>> .v-btn:hover {
    border-color: rgba(255,255,255,1);
}
.menu a {
    color: white;
    font-weight: 500;
    font-size: 16px;
    margin-right: 32px;
    white-space: nowrap;
}
.menu a.router-link-active, .menu a:hover, .menu a:hover .v-icon {
    color: #51e14c;
}
.menu >>> .v-toolbar__content, .menu >>> .v-toolbar__extension {
    padding: 0;
}
.menu .products a {
    margin-right: 0;
}

.menu >>> .v-toolbar__extension {
    background-color: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.17);
}

.submenu {
    align-items: end;
}
.submenu >>> a {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
    white-space: nowrap;
}
.submenu >>> a:hover {
    color: #32BF2D !important;
}
.submenu >>> a.router-link-active {
    color: #32BF2D !important;
    border-bottom: 1px solid #32BF2D;
}
.submenu >>> .v-slide-group__prev {
    justify-content: left;
    min-width: 40px;
}
.submenu >>> .v-slide-group__next {
    justify-content: right;
    min-width: 40px;
}

.footer {
    border-top: thin solid var(--border-color);
    justify-content: center;
    font-size: 14px;
    line-height: 2;
}
.footer >>> a {
    color: grey;
    font-weight: 500;
    margin-right: 20px;
    white-space: nowrap;
}
.footer a.router-link-active, .footer >>> a:hover {
    color: #3ba837;
}
.footer .copy {
    color: var(--text-color-dimmed);
}
</style>
